import React from 'react';

import BreadCrumbRefundRaisePage from '../../common/BreadCrumbRefundRaisePage/BreadCrumbRefundRaise';
import * as S from './RefundRaiseRequestPageHeader.styles';

const breadCrumbData = [
    {
        id: 'vhjiod123232',
        text: 'MyWallet',
        url: ' / myrefundrequests / '
    },
    {
        id: 'vhjiodbhjkisdop',
        text: 'Raise/View Request'
    },
];

const RefundRaiseRequestPageHeader = () => {
    return (
        <S.PgHeader>
            <S.PgHeaderInr>
                <BreadCrumbRefundRaisePage listData={breadCrumbData} />
            </S.PgHeaderInr>
        </S.PgHeader>
    )
}

export default RefundRaiseRequestPageHeader;